<div class="home-main page__main-col page__main-col--with-sidebar" [active]="active" [credit]="credit"
     [renewal]="renewal" [validatePhone]="!verified" [products]="products"></div>
<div class="home-sidebar page__sidebar-col" [chartClass]="chartClass" [numOfDeg]="transformString"
     [numOfDegreesToShow]="numberOfDegreesToShow" style="padding: 0px;"></div>
